import { Tabs } from '@mantine/core';

import classes from './Tabs.module.css';

// TODO: (UI) Update tab hover states to match design - Sem0701
const TabDefaults = Tabs.extend({
  defaultProps: {
    color: 'cobalt',
  },
  classNames: {
    tab: classes.tab,
    list: classes.list,
    panel: classes.panel,
  },
});

export { TabDefaults, Tabs };
